import React, { useState } from "react";
import { useAuth } from "../AuthProvider";
import "../pageLayout.css";
import { API_PUBLIC_SIGNUP_URL } from "../utils/apiUrlList";

const Signup = ({ onCancel }) => {
  const [signupData, setSignupData] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    address: "",
    streetAddress: "",
    city: "",
    postalCode: "",
    state: "",
    country: "",
  });
  const [signupMessage, setSignupMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!signupData.firstName.trim())
      newErrors.firstName = "First name is required";
    if (!signupData.lastName.trim())
      newErrors.lastName = "Last name is required";
    if (!signupData.phoneNumber.trim())
      newErrors.phoneNumber = "Phone number is required";
    if (!signupData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(signupData.email)) {
      newErrors.email = "Email is invalid";
    }
    // if (!signupData.streetAddress.trim()) newErrors.streetAddress = "Street Address is required";
    // if (!signupData.city.trim()) newErrors.city = "City is required";
    // if (!signupData.postalCode.trim()) newErrors.postalCode = "Postal Code is required";
    // if (!signupData.state.trim()) newErrors.state = "State is required";
    // if (!signupData.country.trim()) newErrors.country = "Country is required";
    // if (!signupData.password) {
    //   newErrors.password = "Password is required";
    // } else if (signupData.password.length < 6) {
    //   newErrors.password = "Password must be at least 6 characters";
    // }
    if (!signupData.password) {
      newErrors.password = "Password is required";
    } else {
      const password = signupData.password;

      // Azure AD password complexity:
      // Minimum 8 characters
      // Must contain uppercase, lowercase, number, and special character
      const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_\-+=])[A-Za-z\d@$!%*?&#^()_\-+=]{8,}$/;

      if (!passwordRegex.test(password)) {
        newErrors.password =
          "Password must be at least 8 characters and include uppercase, lowercase, number, and special character";
      }
    }

    if (!signupData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (signupData.password !== signupData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSignupSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    fetch(API_PUBLIC_SIGNUP_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(signupData),
      credentials: "include",
    })
      .then(async (response) => {
        const text = await response.text();
        if (response.ok) {
          // setSignupMessage('Signup successful! You can now login.');
          setSuccess(true);
          window.location.href = "/";
          // Optional: automatically go back to login after some delay or keep the message
        } else {
          setSignupMessage("Signup failed: " + text);
        }
      })
      .catch((err) => {
        setSignupMessage("Signup error: " + err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="signup-container">
      <h2 className="title">Sign Up</h2>
      {!success ? (
        <form onSubmit={handleSignupSubmit} className="signup-form">
          <input
            type="text"
            placeholder="First Name*"
            className={`signup-input ${errors.firstName ? "error" : ""}`}
            value={signupData.firstName}
            onChange={(e) =>
              setSignupData({ ...signupData, firstName: e.target.value })
            }
          />
          {errors.firstName && (
            <span className="error-text">{errors.firstName}</span>
          )}
          <input
            type="text"
            placeholder="Last Name*"
            className={`signup-input ${errors.lastName ? "error" : ""}`}
            value={signupData.lastName}
            onChange={(e) =>
              setSignupData({ ...signupData, lastName: e.target.value })
            }
          />
          {errors.lastName && (
            <span className="error-text">{errors.lastName}</span>
          )}
          <input
            type="tel"
            inputMode="numeric"
            autoComplete="tel"
            placeholder="Phone Number*"
            className={`signup-input ${errors.phoneNumber ? "error" : ""}`}
            value={signupData.phoneNumber || ""}
            onChange={(e) =>
              setSignupData({ ...signupData, phoneNumber: e.target.value })
            }
          />
          {errors.phoneNumber && (
            <span className="error-text">{errors.phoneNumber}</span>
          )}
          <input
            type="email"
            placeholder="Email*"
            className={`signup-input ${errors.email ? "error" : ""}`}
            value={signupData.email}
            onChange={(e) =>
              setSignupData({ ...signupData, email: e.target.value })
            }
          />

          {errors.email && <span className="error-text">{errors.email}</span>}
          <input
            type="password"
            placeholder="Password*"
            className={`signup-input ${errors.password ? "error" : ""}`}
            value={signupData.password}
            onChange={(e) =>
              setSignupData({ ...signupData, password: e.target.value })
            }
          />
          {errors.password && (
            <span className="error-text">{errors.password}</span>
          )}
          <div className="password-note">
            <strong>Password requirements:</strong>
            <ul>
              <li>At least 8 characters</li>
              <li>Must include uppercase and lowercase letters</li>
              <li>
                Must include at least one number and one special character
                (e.g., !, @, #, $)
              </li>
            </ul>
          </div>
          <input
            type="password"
            placeholder="Confirm Password*"
            className={`signup-input ${errors.confirmPassword ? "error" : ""}`}
            value={signupData.confirmPassword || ""}
            onChange={(e) =>
              setSignupData({ ...signupData, confirmPassword: e.target.value })
            }
          />

          {errors.confirmPassword && (
            <span className="error-text">{errors.confirmPassword}</span>
          )}
          <details className="signup-optional">
            <summary>Address (optional)</summary>
            <div className="signup-optional-fields">
              <input
                type="text"
                autoComplete="street-address"
                placeholder="Street Address"
                className={`signup-input ${errors.streetAddress ? "error" : ""}`}
                value={signupData.streetAddress || ""}
                onChange={(e) =>
                  setSignupData({
                    ...signupData,
                    streetAddress: e.target.value,
                  })
                }
              />
              {errors.streetAddress && (
                <span className="error-text">{errors.streetAddress}</span>
              )}
              <input
                type="text"
                autoComplete="postal-code"
                placeholder="Postal Code"
                className={`signup-input ${errors.postalCode ? "error" : ""}`}
                value={signupData.postalCode || ""}
                onChange={(e) =>
                  setSignupData({ ...signupData, postalCode: e.target.value })
                }
              />
              {errors.postalCode && (
                <span className="error-text">{errors.postalCode}</span>
              )}
              <input
                type="text"
                autoComplete="address-level2"
                placeholder="City"
                className={`signup-input ${errors.city ? "error" : ""}`}
                value={signupData.city || ""}
                onChange={(e) =>
                  setSignupData({ ...signupData, city: e.target.value })
                }
              />
              {errors.city && <span className="error-text">{errors.city}</span>}
              <input
                type="text"
                autoComplete="address-level1"
                placeholder="State/Province"
                className={`signup-input ${errors.state ? "error" : ""}`}
                value={signupData.state || ""}
                onChange={(e) =>
                  setSignupData({ ...signupData, state: e.target.value })
                }
              />
              {errors.state && (
                <span className="error-text">{errors.state}</span>
              )}
              <input
                type="text"
                autoComplete="country-name"
                placeholder="Country/Region"
                className={`signup-input ${errors.country ? "error" : ""}`}
                value={signupData.country || ""}
                onChange={(e) =>
                  setSignupData({ ...signupData, country: e.target.value })
                }
              />
              {errors.country && (
                <span className="error-text">{errors.country}</span>
              )}
            </div>
          </details>
          <div className="button-group">
            <button
              type="submit"
              className="login-search-button login"
              disabled={loading}
            >
              {loading ? "Registering..." : "Register"}
            </button>
            <button
              type="button"
              className="login-search-button signup"
              onClick={onCancel}
            >
              Cancel
            </button>
          </div>
        </form>
      ) : (
        <div className="signup-success-container">
          {signupMessage && <p className="signup-message">{signupMessage}</p>}
          <button
            type="button"
            className="login-search-button login"
            onClick={onCancel}
            style={{ marginTop: "20px", width: "100%" }}
          >
            Sign Up Successfull Moving you to race results page
          </button>
        </div>
      )}
      {!success && signupMessage && (
        <p className="signup-message">{signupMessage}</p>
      )}
    </div>
  );
};

export default Signup;
